import React from 'react';
import { LockIcon } from '../../icons/redesignIcons';

import './ReadOnlyField.css';

const ReadOnlyField = ({ label, value }) => (
  <div className="ReadOnlyField">
    <label>{label}</label>
    <div className="ReadOnlyFieldValue">
      <span>{value}</span>
      <LockIcon />
    </div>
  </div>
);

export default ReadOnlyField;
